import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { isNil } from 'ramda'
import config from '@/config'
import { DisplayTable } from '@/features/Application/elements/tables'
import {
  LabeledValue,
  LabelText,
  ValueText,
  Wrapper,
  DocumentView,
  EmptyComponent
} from '@/features/Application/elements'

const { BACKEND_SERVER } = config

const InsuranceView = ({ application = {}, isLocked, applicationLoading }) => {
  const { t } = useTranslation()
  const { insurance } = application
  const title = t(
    'l.application.view.tenant_insurance_information.label',
    'Tenant Insurance Information'
  )
  const handleClick = () => {
    window.open(`${BACKEND_SERVER}/secure/${insurance?.tag}/${insurance?.id}/form.png`, '_blank')
  }
  const data = useMemo(
    () => [
      {
        id: 'Insurance Provider',
        cell: (
          <LabeledValue
            key="Insurance Provider"
            label={
              <LabelText>
                {t('l.application.view.insurance_provider.label', 'Insurance Provider')}
              </LabelText>
            }
            value={
              <ValueText isLocked={isLocked}>
                {insurance?.metadata?.insurance_company_name || '-'}
              </ValueText>
            }
          />
        )
      },
      {
        id: 'Policy Number',
        cell: (
          <LabeledValue
            key="Policy Number"
            label={
              <LabelText>{t('l.application.view.policy_number.label', 'Policy Number')}</LabelText>
            }
            value={
              <ValueText isLocked={isLocked}>{insurance?.metadata?.policy_number || '-'}</ValueText>
            }
          />
        )
      },
      {
        id: 'Insurance Policy',
        cell: (
          <LabeledValue
            key="Insurance Policy"
            label={
              <LabelText>
                {t('l.application.view.insurance_policy.label', 'Insurance Policy')}
              </LabelText>
            }
            value={<DocumentView isLocked={isLocked} onClick={handleClick} />}
          />
        )
      }
    ],
    [applicationLoading]
  )
  const tableData = isNil(insurance) ? [] : data

  return (
    <Wrapper>
      <DisplayTable
        data={tableData}
        title={title}
        columns={2}
        emptyComponent={
          <EmptyComponent isLoading={applicationLoading}>
            {t(
              'l.application.view.no_insurance.label',
              'No insurance included in this application.'
            )}
          </EmptyComponent>
        }
      />
    </Wrapper>
  )
}

export default InsuranceView
